// extracted by mini-css-extract-plugin
module.exports = {"uploadLabel":"styles_uploadLabel__30xxT","hiddenInput":"styles_hiddenInput__FjJCC"};